export const SETTINGS_TABS = [
  'Account',
  'Organizations',
  'Preferences',
  'Admin Dashboard',
] as const

export type SettingsTab = (typeof SETTINGS_TABS)[number]

export const DEFAULT_SETTINGS_TAB: SettingsTab = 'Account'

export const parseSettingsTab = (value: string): SettingsTab => {
  const match = SETTINGS_TABS.find(
    (tab) => tab.toLowerCase() === value.toLowerCase(),
  )
  return match ?? DEFAULT_SETTINGS_TAB
}

export const serializeSettingsTab = (value: SettingsTab): string =>
  value.toLowerCase()
